"use client";

import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useCheckboxStore } from "../__chunks/ISFXQ47C.js";
import { useCheckbox } from "../__chunks/6P23IZ5Z.js";
import "../__chunks/3YZMJGQP.js";
import { useMenuItem } from "../__chunks/UXB73EBH.js";
import { useMenuScopedContext } from "../__chunks/SJPAIJOW.js";
import "../__chunks/QVEJ36PB.js";
import "../__chunks/L63MOBXC.js";
import "../__chunks/EYKMH5G5.js";
import "../__chunks/NSB34BGG.js";
import "../__chunks/SZHY72KI.js";
import "../__chunks/ZHUQ44XA.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/DPAO6G5R.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef, memo } from "../__chunks/7FZLUSKW.js";
import "../__chunks/CTKPPFRS.js";
import { useInitialValue } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/menu/menu-item-checkbox.tsx
import { invariant, shallowEqual } from "@ariakit/core/utils/misc";
import { useEffect } from "react";
var TagName = "div";
function getPrimitiveValue(value) {
  if (Array.isArray(value)) {
    return value.toString();
  }
  return value;
}
function getValue(storeValue, value, checked) {
  if (value === void 0) {
    if (Array.isArray(storeValue)) return storeValue;
    return !!checked;
  }
  var primitiveValue = getPrimitiveValue(value);
  if (!Array.isArray(storeValue)) {
    if (checked) {
      return primitiveValue;
    }
    return storeValue === primitiveValue ? false : storeValue;
  }
  if (checked) {
    if (storeValue.includes(primitiveValue)) {
      return storeValue;
    }
    return [].concat(_toConsumableArray(storeValue), [primitiveValue]);
  }
  return storeValue.filter(function (v) {
    return v !== primitiveValue;
  });
}
var useMenuItemCheckbox = createHook(function useMenuItemCheckbox2(_a) {
  var _b = _a,
    store = _b.store,
    name = _b.name,
    value = _b.value,
    checked = _b.checked,
    defaultCheckedProp = _b.defaultChecked,
    _b$hideOnClick = _b.hideOnClick,
    hideOnClick = _b$hideOnClick === void 0 ? false : _b$hideOnClick,
    props = __objRest(_b, ["store", "name", "value", "checked", "defaultChecked", "hideOnClick"]);
  var context = useMenuScopedContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "MenuItemCheckbox must be wrapped in a MenuList or Menu component");
  var defaultChecked = useInitialValue(defaultCheckedProp);
  useEffect(function () {
    store == null ? void 0 : store.setValue(name, function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!defaultChecked) return prevValue;
      return getValue(prevValue, value, true);
    });
  }, [store, name, value, defaultChecked]);
  useEffect(function () {
    if (checked === void 0) return;
    store == null ? void 0 : store.setValue(name, function (prevValue) {
      return getValue(prevValue, value, checked);
    });
  }, [store, name, value, checked]);
  var checkboxStore = useCheckboxStore({
    value: store.useState(function (state) {
      return state.values[name];
    }),
    setValue: function setValue(internalValue) {
      store == null ? void 0 : store.setValue(name, function () {
        if (checked === void 0) return internalValue;
        var nextValue = getValue(internalValue, value, checked);
        if (!Array.isArray(nextValue)) return nextValue;
        if (!Array.isArray(internalValue)) return nextValue;
        if (shallowEqual(internalValue, nextValue)) return internalValue;
        return nextValue;
      });
    }
  });
  props = __spreadValues({
    role: "menuitemcheckbox"
  }, props);
  props = useCheckbox(__spreadValues({
    store: checkboxStore,
    name: name,
    value: value,
    checked: checked
  }, props));
  props = useMenuItem(__spreadValues({
    store: store,
    hideOnClick: hideOnClick
  }, props));
  return props;
});
var MenuItemCheckbox = memo(forwardRef(function MenuItemCheckbox2(props) {
  var htmlProps = useMenuItemCheckbox(props);
  return createElement(TagName, htmlProps);
}));
export { MenuItemCheckbox, useMenuItemCheckbox };